import React from "react";
import { ToastContainer } from "react-toastify";
import { AddContent } from "../components/CMS/Contents/AddContent";

export const ContentsAdd = () => {
  return (
    <div className="main-content">
      <div className="page-content">
        <div className="container-fluid">
          <ToastContainer
            position="top-right"
            autoClose={5000}
            hideProgressBar={false}
          />
          <AddContent />
        </div>
      </div>
    </div>
  );
};
